import React from 'react';

import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import { AppColors } from '@/components/lib/theme';

import { useEventTimeInfo } from '../hooks/use-event-time-info';

type EventTimeInfoProps = {
    eventId: string;
    color: AppColors;
    isSuspended?: boolean;
};

export const EventTimeInfo = ({ eventId, color, isSuspended }: EventTimeInfoProps) => {
    const { timeInfo, isLive } = useEventTimeInfo(eventId);

    if (!timeInfo) {
        return null;
    }

    const timeColor = !isSuspended && isLive ? ds.colorToken.text.danger : color;

    return (
        <>
            <Text variant="bodySmall" color={color}>
                {' • '}
            </Text>
            <Text variant="bodySmall" color={timeColor}>
                {timeInfo}
            </Text>
        </>
    );
};
